// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XngGaCustomVirtualPageViewEvent } from "@ces/App/Handlers/GoogleAnalytics/XngGaCustomVirtualPageViewEvent";
import { CustomAppState } from "@ces/App/Store/Reducers";
import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import setNotes from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetNotes";

const xPopulateApiParameter: typeof PopulateApiParameter = props => {
    const state = props.getState() as CustomAppState;
    const { editedCartNotes } = state.pages.checkoutShipping;
    const notes = typeof editedCartNotes === "undefined" ? props.apiParameter.cart.notes : editedCartNotes || "";

    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            notes,
        } as any,
    };
};

const xResetCheckoutNotes: typeof PopulateApiParameter = props => {
    props.dispatch(setNotes({ notes: "" }));
};

addToChainAfter(chain, PopulateApiParameter, xPopulateApiParameter);
addToEndOfChain(chain, xResetCheckoutNotes);
addToEndOfChain(chain, XngGaCustomVirtualPageViewEvent);
